export enum AdjustMode {
  shift,
  unshift,
}

export class EditorHistory {
  content: string;
  cursorPosition: number;
}

export class EditorTitle {
  initialValue: string;
  currentValue: string;
  constructor() {
    this.initialValue = '';
    this.currentValue = '';
  }
}
export class ExpressionHistory {
  undo: EditorHistory[];
  redo: EditorHistory[];
  constructor() {
    this.undo = [];
    this.redo = [];
  }
}

export class CursorBackUp {
  node: Node;
  offset: number;
}
